var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasFile
    ? _c(
        "div",
        { staticClass: "pdf-form-viewer" },
        [
          _vm.showFieldList && _vm.loaded && _vm.fields.length
            ? _c(
                "aside",
                { staticClass: "pdf-form-viewer__sidebar" },
                [
                  _c("div", { staticClass: "pdf-form-viewer__sidebar-title" }, [
                    _vm._v(" Campos a completar "),
                    _c(
                      "span",
                      {
                        staticClass: "pdf-form-viewer__sidebar-count",
                        class: { "is-ok": _vm.invalidCount === 0 }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.fields.length - _vm.invalidCount) +
                            "/" +
                            _vm._s(_vm.fields.length) +
                            " "
                        )
                      ]
                    )
                  ]),
                  _vm._l(_vm.fieldsByPage, function(group) {
                    return _c(
                      "div",
                      {
                        key: group.page,
                        staticClass: "pdf-form-viewer__page-group"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pdf-form-viewer__page-head",
                            class: {
                              "is-current": group.page === _vm.actualPage,
                              "is-ok": group.pending === 0,
                              "has-pending": group.pending > 0
                            },
                            on: {
                              click: function($event) {
                                return _vm.goToPage(group.page)
                              }
                            }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "pdf-form-viewer__page-dot" },
                              [
                                _c("feather-icon", {
                                  attrs: {
                                    icon:
                                      group.pending === 0
                                        ? "CheckCircleIcon"
                                        : "AlertCircleIcon",
                                    size: "14"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "span",
                              { staticClass: "pdf-form-viewer__page-title" },
                              [_vm._v("Página " + _vm._s(group.page))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "pdf-form-viewer__page-count",
                                class: { "is-ok": group.pending === 0 }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(group.done) +
                                    "/" +
                                    _vm._s(group.fields.length) +
                                    " "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "ul",
                          { staticClass: "pdf-form-viewer__sidebar-list" },
                          _vm._l(group.fields, function(field) {
                            return _c(
                              "li",
                              {
                                key: field.id,
                                staticClass: "pdf-form-viewer__sidebar-item",
                                class: {
                                  "is-done": _vm.isFieldComplete(field),
                                  "is-active": field.id === _vm.highlightedId
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.goToField(field)
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "pdf-form-viewer__sidebar-check"
                                  },
                                  [
                                    _c("feather-icon", {
                                      attrs: {
                                        icon: _vm.isFieldComplete(field)
                                          ? "CheckCircleIcon"
                                          : "CircleIcon",
                                        size: "14"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "pdf-form-viewer__sidebar-name",
                                    attrs: { title: field.label }
                                  },
                                  [
                                    _vm._v(" " + _vm._s(field.label)),
                                    field.required
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "pdf-form-viewer__req"
                                          },
                                          [_vm._v("*")]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _c("div", { staticClass: "pdf-form-viewer__main" }, [
            _c(
              "div",
              { staticClass: "pdf-form-viewer__toolbar" },
              [
                _vm.pages && _vm.loaded
                  ? _c("PdfViewportTools", {
                      attrs: { pages: _vm.pages },
                      model: {
                        value: _vm.page,
                        callback: function($$v) {
                          _vm.page = $$v
                        },
                        expression: "page"
                      }
                    })
                  : _vm._e(),
                _vm.loaded
                  ? _c("div", { staticClass: "pdf-form-viewer__status" }, [
                      _c(
                        "span",
                        {
                          staticClass: "pdf-form-viewer__missing",
                          class: { "is-ok": _vm.invalidCount === 0 }
                        },
                        [
                          _vm.invalidCount === 0
                            ? [_vm._v("Completo")]
                            : [
                                _vm._v(
                                  _vm._s(_vm.invalidCount) +
                                    " campo(s) con error"
                                )
                              ]
                        ],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "pdf-form-viewer__zoom" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { size: "sm", variant: "outline-primary" },
                              on: { click: _vm.zoomOut }
                            },
                            [
                              _c("feather-icon", {
                                attrs: { icon: "ZoomOutIcon" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "span",
                            { staticClass: "pdf-form-viewer__zoom-label" },
                            [_vm._v(_vm._s(_vm.zoomPercent) + "%")]
                          ),
                          _c(
                            "b-button",
                            {
                              attrs: { size: "sm", variant: "outline-primary" },
                              on: { click: _vm.zoomIn }
                            },
                            [
                              _c("feather-icon", {
                                attrs: { icon: "ZoomInIcon" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                size: "sm",
                                variant: "outline-secondary"
                              },
                              on: { click: _vm.resetZoom }
                            },
                            [_vm._v(" 100% ")]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { ref: "scroll", staticClass: "pdf-form-viewer__scroll" },
              [
                _c(
                  "div",
                  {
                    staticClass: "pdf-form-viewer__zoom-frame",
                    style: _vm.zoomFrameStyle
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "page",
                        staticClass: "pdf-form-viewer__page",
                        style: _vm.pageStyle
                      },
                      [
                        _c("Pdf", {
                          ref: "pdf",
                          staticClass: "pdf-form-viewer__canvas",
                          attrs: { page: _vm.actualPage, src: _vm.file },
                          on: {
                            "num-pages": _vm.onNumPages,
                            "page-loaded": _vm.onPageLoaded,
                            "page-size": _vm.onPageSize
                          }
                        }),
                        _c(
                          "div",
                          { staticClass: "pdf-form-viewer__overlay" },
                          _vm._l(_vm.fieldsOnPage, function(field) {
                            return _c(
                              "div",
                              {
                                key: field.id,
                                ref: "field-" + field.id,
                                refInFor: true,
                                staticClass: "pdf-form-viewer__field",
                                class: {
                                  "is-highlighted":
                                    field.id === _vm.highlightedId
                                },
                                style: _vm.fieldStyle(field)
                              },
                              [
                                field.label
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pdf-form-viewer__field-label",
                                        attrs: { title: field.label }
                                      },
                                      [
                                        _vm._v(" " + _vm._s(field.label)),
                                        field.required
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pdf-form-viewer__req"
                                              },
                                              [_vm._v("*")]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e(),
                                _c("FieldInput", {
                                  attrs: {
                                    field: field,
                                    value: _vm.values[_vm.valueKey(field)],
                                    "font-size-px": _vm.fontSizePxFor(field),
                                    error: _vm.showErrors
                                      ? _vm.fieldError(field)
                                      : null
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.setValue(field, $event)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
            )
          ]),
          _c("b-overlay", { attrs: { show: !_vm.loaded, "no-wrap": "" } })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }